import { useEffect } from 'react'

import { isJetonWallet } from 'mmfintech-checkout-commons'
import { isMultiItemArray, isSingleItemArray, isValidArray, tr } from 'mmfintech-commons'

import { PaymentMethodButton } from './PaymentMethodButton'

import type { PaymentOptionResponse } from 'mmfintech-checkout-commons/types'

import './selectMethod.scss'

type SelectMethodProps = {
  method: string
  setMethod: (method: string) => void
  paymentOptions: PaymentOptionResponse[]
  errorVisible?: boolean
  jetonBankSpecialCase?: boolean
}

const SelectMethod = (props: SelectMethodProps) => {
  const { method, setMethod, paymentOptions, errorVisible, jetonBankSpecialCase } = props

  useEffect(() => {
    if (isSingleItemArray(paymentOptions) && (!method || method !== paymentOptions[0].paymentMethod)) {
      setMethod(paymentOptions[0].paymentMethod)
    }
  }, [paymentOptions, method, setMethod])

  if (isMultiItemArray(paymentOptions)) {
    return (
      <div className='select-method-wrapper'>
        <div className='heading'>{tr('CHECKOUT.PAYMENT.METHOD_LABEL', 'Select payment method')}</div>
        <div className='container'>
          {paymentOptions.map(option => (
            <PaymentMethodButton
              key={option.paymentMethod}
              name={option.paymentMethod}
              selected={option.paymentMethod === method}
              onClick={() => setMethod(option.paymentMethod)}
            />
          ))}
        </div>
      </div>
    )
  }

  if (!isValidArray(paymentOptions) && errorVisible) {
    return (
      <div className='select-method-wrapper'>
        <div className='message-empty' data-test='no-methods-error'>
          {tr('CHECKOUT.PAYMENT.NO_METHODS', 'No payment methods available')}
        </div>
      </div>
    )
  }

  if (jetonBankSpecialCase && isJetonWallet(method)) {
    return (
      <div className='select-method-wrapper'>
        <div className='heading'>
          {tr('CHECKOUT.PAYMENT.PAY_BY', 'Pay with {{METHOD}}', {
            METHOD: tr('METADATA.PAYMENT_OPTIONS.INSTANT_BANK_TRANSFER', 'Instant bank transfer')
          })}
        </div>
      </div>
    )
  }

  if (method && errorVisible) {
    return (
      <div className='select-method-wrapper'>
        <div className='heading'>
          {tr('CHECKOUT.PAYMENT.PAY_BY', 'Pay with {{METHOD}}', {
            METHOD: tr(`METADATA.PAYMENT_OPTIONS.${method}`, method)
          })}
        </div>
      </div>
    )
  }

  return null
}

export default SelectMethod
